import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as d3 from "d3";
import React, { useEffect, useRef, useState } from "react";
const Linechart = ({ colors = [], height, trendsData, width }) => {
    const trendsDataLengths = trendsData.map((data) => data.length);
    const maxLength = Math.max(...trendsDataLengths);
    const [datasets] = useState(trendsData);
    const svgRef = useRef(undefined);
    const max_domain_soc = 100;
    const max_domain_power = Math.max(...trendsData[1]);
    const min_value = 0;
    const margin = { top: 0 };
    const y_rect_value = 0;
    const x_rect1_value = 0;
    const x_rect2_value = 46;
    const x_rect3_value = 91;
    const x_rect4_value = 136;
    useEffect(() => {
        drawLineChart();
    }, [datasets]);
    function drawLineChart() {
        const svg = d3
            .select(svgRef.current)
            .attr("width", width)
            .attr("height", height)
            .style("background", "white")
            .style("margin-top", margin.top);
        // Setting up scaling
        const xScale = d3
            .scaleLinear()
            .domain([0, maxLength - 1]) // Assuming all datasets have the same length
            .range([0, width]);
        const yScaleLeft = d3.scaleLinear().domain([min_value, max_domain_soc]).range([height, 0]);
        const yScaleRight = d3.scaleLinear().domain([min_value, max_domain_power]).range([height, 0]);
        // Setting up axes
        const xAxis_soc = d3.axisBottom(xScale);
        const yAxisLeft = d3.axisLeft(yScaleLeft);
        const yAxisRight = d3.axisRight(yScaleRight);
        svg.append("g").call(xAxis_soc).attr("stroke-width", "3px").attr("transform", `translate(0, ${height})`);
        svg.append("g").attr("stroke-width", "3px").call(yAxisLeft);
        svg.append("g")
            .attr("transform", `translate(${width}, 0)`) // Move to the right edge
            .attr("stroke-width", "3px")
            .call(yAxisRight);
        // Pad shorter datasets with null values to align them
        const paddedDatasets = datasets.map((dataset) => {
            const padding = Array(maxLength - dataset.length).fill(null);
            return [...dataset, ...padding];
        });
        const lineGenerator_soc = d3
            .line()
            .defined((d) => d !== null) // Ignore null values
            .x((_, index) => xScale(index))
            .y((d) => yScaleLeft(d)) // Cast to number since nulls are filtered out
            // .y(yScaleLeft)
            .curve(d3.curveCardinal);
        const lineGenerator_power = d3
            .line()
            .defined((d) => d !== null) // Ignore null values
            .x((_, index) => xScale(index))
            .y((d) => yScaleRight(d)) // Cast to number since nulls are filtered out
            // .y(yScaleRight)
            .curve(d3.curveCardinal);
        paddedDatasets.forEach((dataset, index) => {
            const lineGen = index % 2 === 0 ? lineGenerator_soc : lineGenerator_power; // Alternate between lineGenerator_soc and lineGenerator_power
            svg.append("path")
                .datum(dataset)
                .attr("fill", "none")
                .attr("stroke", colors[index] || d3.schemeCategory10[index % 10]) // Use provided color or fallback to D3's color scheme
                .attr("stroke-width", "2px")
                .attr("d", lineGen);
        });
    }
    return (_jsx("div", { children: _jsxs("svg", { "data-test": "linechart-svg", ref: svgRef, children: [_jsx("rect", { fill: "#86BDEB", height: height, width: width / 4, x: x_rect1_value, y: y_rect_value }), _jsx("rect", { fill: "#86BDEB", height: height, width: width / 4 - 1, x: x_rect2_value, y: y_rect_value }), _jsx("rect", { fill: "#86BDEB", height: height, width: width / 4 - 1, x: x_rect3_value, y: y_rect_value }), _jsx("rect", { fill: "#86BDEB", height: height, width: width / 4 - 1, x: x_rect4_value, y: y_rect_value })] }) }));
};
export default Linechart;
